<!-- Loading overlay for initial data load -->
@if (isLoadingOverall$ | async) {
<div class="fixed top-0 left-0 w-full h-full flex flex-column align-items-center justify-content-center" style="z-index: 9999;">
    <p-progressSpinner [style]="{'width': '50px', 'height': '50px'}"></p-progressSpinner>
    <p class="mt-3 text-color-secondary text-lg">Loading job data...</p>
</div>
}

<!-- Main content - shown when initial loading is complete -->
@if (!(isLoadingOverall$ | async)) {

@if ( hasNoJobs$ | async) {
@if (company$ | async; as company) {
@if (roles$ | async; as roles) {
<div class="grid">
    <div class="col-12 lg:col-10 lg:col-offset-1">
        <div class="empty-jobs-state p-4 md:p-5">
            <div class="empty-jobs-icon-wrap">
                <i class="pi pi-briefcase empty-jobs-icon"></i>
            </div>
            <h2 class="empty-jobs-title">No jobs yet for {{company.companyName}}</h2>
            @if (company.companyType == 'Service Provider') {
            <p class="empty-jobs-copy">
                Create your first job to start tracking dashboards, files, and workbook activity.
            </p>
            } @else {
            <p class="empty-jobs-copy">
                Jobs will appear here once a linked service provider creates and starts sharing them.
            </p>
            }

            @if (company.companyType == 'Service Provider' && roles.isEditorOrAdmin(company.companyId)) {
            <button pButton type="button"
                    class="empty-jobs-action"
                    [disabled]="isLoadingAny$ | async"
                    (click)="navigateToAddVendorJob()">
                <i pButtonIcon class="fa fa-plus"></i>
                <span pButtonLabel>Create Your First Job</span>
            </button>
            }

            @if (company.companyType == 'Service Provider' && !roles.isEditorOrAdmin(company.companyId)) {
            <p class="empty-jobs-note">
                You do not currently have permission to create jobs for this company.
            </p>
            }
        </div>
    </div>
</div>
}
}
}

<!-- Jobs accordion -->
@if (!(hasNoJobs$ | async)) {
<p-accordion [multiple]="true">
    @if(groupedVendorJobs$ | async; as groupedVendorJobs){
    @for (companyAndJobs of groupedVendorJobs; track $index) {
    <p-accordion-panel *ngIf="isUserCompanyVendor$ | async" [value]="$index">
        <p-accordion-header>{{ 'Service Provider Jobs - ' + companyAndJobs.companyName }}</p-accordion-header>
        <p-accordion-content>
        <div class="grid">
            @if (company$ | async; as company) {
            @if (company.companyId == companyAndJobs.companyId) {
            <div class="col-12">
                <button pButton type="button" 
                        [disabled]="isLoadingAny$ | async"
                    (click)="navigateToAddVendorJob()">
                    <i pButtonIcon class="fa fa-plus"></i>
                    <span pButtonLabel>Create Job</span>
                </button>
            </div>
            }
            }
            <div class="col-12">
                @if (roles$ | async; as roles) {

                <p-table #vendorDt [columns]="vendorJobCols" [value]="companyAndJobs.jobs" 
                         [scrollable]="true" [paginator]="true" [rows]="20"
                         [loading]="isLoadingVendorJobs$ | async">
                    <!-- ...existing table template content... -->
                    <ng-template #header let-columns>
                        <tr>
                            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [style.max-width]="col.width">
                                {{col.header}}
                                <p-sortIcon *ngIf="col.field != ''" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                        <tr>
                            <th *ngFor="let col of columns" [ngSwitch]="col.field">
                                <div *ngSwitchCase="'name'">
                                    <input pInputText type="text"
                                        (input)="vendorDt.filter($event.target.value, col.field, col.filterMatchMode)"
                                        style="width: 100%;" />
                                </div>
                                <div *ngSwitchCase="'apiNumber'">
                                    <input pInputText type="text"
                                        (input)="vendorDt.filter($event.target.value, col.field, col.filterMatchMode)"
                                        style="width: 100%;" />
                                </div>
                                <div *ngSwitchCase="'wellInfo.name'">
                                    <input pInputText type="text"
                                        (input)="vendorDt.filter($event.target.value, col.field, col.filterMatchMode)"
                                        style="width: 100%;" />
                                </div>
                                <div *ngSwitchCase="'consumerCompanyName'">
                                    <input pInputText type="text"
                                        (input)="vendorDt.filter($event.target.value, col.field, col.filterMatchMode)"
                                        style="width: 100%;" />
                                </div>
                                <div *ngSwitchCase="'deviceNamesAsString'">
                                    <input pInputText type="text"
                                        (input)="vendorDt.filter($event.target.value, col.field, col.filterMatchMode)"
                                        style="width: 100%;" />
                                </div>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template #body let-job>
                        <tr>
                            <td>{{job.name}}</td>
                            <td>{{job.apiNumber}}</td>
                            <td>{{job.wellInfo.name}}</td>
                            <td>{{job.consumerCompanyName}}  
                                          <i class="far fa-chart-bar actionIcon mr-1 mb-1 fa-xl" 
                                   [class.opacity-50]="isLoadingDashboardLink$ | async"
                                   (click)="navigateToConsumerDashboardFromVendor(job.consumerJobId)"
                                   pTooltip="Navigate to the Consumer Job Dashboard." tooltipPosition="left"></i>
                            </td>
                            <td>{{job.startTime | date: 'MM/dd/yy HH:mm'}}</td>
                            <td>{{job.endTime | date: 'MM/dd/yy HH:mm'}}</td>
                            <td>{{job.deviceNamesAsString}}</td>
                            <td>                                <i class="far fa-edit actionIcon mr-1 mb-1 fa-xl" (click)="navigateToVendorDetail(job.id)"
                                    pTooltip="Navigate to Details for this Job." tooltipPosition="left"></i>
                                <i class="far fa-chart-bar actionIcon mr-1 mb-1 fa-xl" 
                                   [class.opacity-50]="isLoadingDashboardLink$ | async"
                                   (click)="navigateToVendorDashboard(job.id)"
                                   pTooltip="Navigate to the Job Dashboard." tooltipPosition="left"></i>
                                <i class="fa fa-book actionIcon mr-1 mb-1 fa-xl" (click)="navigateToVendorWorkbook(job)"
                                    pTooltip="Navigate to the Job Workbook." tooltipPosition="left"></i>
                                <i *ngIf="roles.isEditorOrAdmin(job.companyId)" class="fa fa-table actionIcon mr-1 mb-1 fa-xl"
                                    (click)="downloadJobExport(job.id)" pTooltip="Download the Job 'DATA' Export"
                                    tooltipPosition="left"></i>
                                <i *ngIf="roles.isEditorOrAdmin(job.companyId)" class="far fa-file actionIcon mr-1 mb-1 fa-xl"
                                    (click)="downloadJobSummaryExport(job.id)"
                                    pTooltip="Download the Job 'SUMMARY' Export" tooltipPosition="left"></i>
                                <i class="far fa-folder-open actionIcon mr-1 mb-1 fa-xl" (click)="openFilePopUp(job.consumerJobId)"
                                    pTooltip="Manage Files for this Job." tooltipPosition="left"></i>
                                <i *ngIf="roles.isGlobalAdmin(job.companyId)" 
                                   class="far fa-trash-alt actionIcon mr-1 mb-1 fa-xl"
                                   [class.opacity-50]="isLoadingDeleteJob$ | async"
                                   (click)="confirmDeleteVendorJob(job)" pTooltip="Delete this Job."
                                   tooltipPosition="left"></i>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template #paginatorleft>
                        Showing {{(vendorDt.totalRecords) < 1 ? 0 : ((vendorDt.first ?? 0) + 1)}} to {{(vendorDt.totalRecords) > 0 ?
                            (((vendorDt.rows ?? 0) + (vendorDt.first ?? 0)) <= (vendorDt.totalRecords) ? ((vendorDt.rows ?? 0) +
                                (vendorDt.first ?? 0)) : (vendorDt.totalRecords)) : 0}} of {{vendorDt.totalRecords}} entries </ng-template>
                </p-table>
                }
            </div>
        </div>
        </p-accordion-content>
    </p-accordion-panel>
    }
    }
    <p-accordion-panel *ngIf="isUserCompanyConsumer$ | async" value="operatorJobs">
        <p-accordion-header>Operator Jobs</p-accordion-header>
        <p-accordion-content>
        @if (roles$ | async; as roles) {
        @if (consumerJobs$ | async; as consumerJobs){
        <p-table #consumerDt [columns]="consumerJobCols" [value]="consumerJobs" 
                 [scrollable]="true" [paginator]="true" [rows]="20"
                 [loading]="isLoadingConsumerJobs$ | async">
            <ng-template #header let-columns>
                <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                        {{col.header}}
                        <p-sortIcon *ngIf="col.field != ''" [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
                <tr>
                    <th *ngFor="let col of columns">
                        <div *ngIf="col.filterMatchMode == 'contains'">
                            <input pInputText type="text"
                                (input)="consumerDt.filter($event.target.value, col.field, col.filterMatchMode)"
                                style="width: 100%;" />
                        </div>
                    </th>
                </tr>
            </ng-template>
            <ng-template #body let-job>
                <tr>
                    <td>{{job.number}}</td>
                    <td>{{job.wellApiNumber}}</td>
                    <td>{{job.wellName}}</td>
                    <td>{{job.vendorCompanyNames}}</td>
                    <td>{{job.startTime | date: 'MM/dd/yy HH:mm'}}</td>
                    <td>{{job.endTime | date: 'MM/dd/yy HH:mm'}}</td>
                    <td>                        <i class="far fa-edit actionIcon mr-1 mb-1 fa-xl" (click)="navigateToConsumerDetail(job.id)"
                            pTooltip="Navigate to Details for this Job." tooltipPosition="left"></i>
                        <i class="far fa-chart-bar actionIcon mr-1 mb-1 fa-xl" 
                           [class.opacity-50]="isLoadingDashboardLink$ | async"
                           (click)="navigateToConsumerDashboard(job)"
                           pTooltip="Navigate to the Job Dashboard." tooltipPosition="left"></i>
                    </td>
                </tr>
            </ng-template>
            <ng-template #paginatorleft>
                Showing {{(consumerDt.totalRecords) < 1 ? 0 : ((consumerDt.first ?? 0) + 1)}} to {{(consumerDt.totalRecords) > 0 ?
                    (((consumerDt.rows ?? 0) + (consumerDt.first ?? 0)) <= (consumerDt.totalRecords) ? ((consumerDt.rows ?? 0) +
                        (consumerDt.first ?? 0)) : (consumerDt.totalRecords)) : 0}} of {{consumerDt.totalRecords}} entries </ng-template>
        </p-table>}}
        </p-accordion-content>
    </p-accordion-panel>
</p-accordion>
}

}

